import React from "react";
import styles from "./../PaymentDetails/PaymentDetailsAtd.module.scss";
import ReactModal from "react-modal";
import { ReactComponent as ATDLogoIcon } from "../../images/global/at.svg";
import { ReactComponent as SWLogoIcon } from "../../images/sw/seaworld-parks-and-entertainment-alt.svg";
import UOLogoIcon from "../../images/uo/uo-logo.png";
import { ThreeDSRedirectURL } from "../GooglePay/googlePay";
import { useTranslation } from "react-i18next";
import { getDomainConfig } from "../../config/config";

const ExternalPaymentsOrderProgressModal = ({ shouldOpen, text, show3ds, handleClose3DSModal }) => {

  const { t } = useTranslation("common");
  const config = getDomainConfig();

  const orderStatusMessages = {
    creating: t("3ds-creating-message"),
    reviewing: t("3ds-reviewing-message"),
    finalizing: t("3ds-finalizing"),
  };

  const getLogo = (domain) => {
    switch(domain) {
      case 'Uo':
        return <img src={UOLogoIcon} alt="UO-logo" />;
      case 'Sw':
        return <SWLogoIcon />;
      default:
        return <ATDLogoIcon />;
    }
  }

  const renderCallbackMessage = () => (
    <>
      <p>{t("3ds-couldnt-process-1")}</p>
      <p>
        {t("3ds-couldnt-process-2")}{" "}
        <a href="#" onClick={handleClose3DSModal}>
          {t("3ds-couldnt-process-tryagain-link")}
        </a>{" "}
        {t("3ds-couldnt-process-3")}{" "}
        <a href="../../contact-us">
          {t("3ds-couldnt-process-contact-link")}
        </a>{" "}
        {t("3ds-couldnt-process-4")}
      </p>
    </>
  );

  return (
    <ReactModal
      isOpen={shouldOpen}
      className={styles.modal}
      overlayClassName={styles.modalOverlay}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      onAfterOpen={() => (document.body.style.overflow = "hidden")}
      onAfterClose={() => (document.body.style.overflow = "unset")}
    >
      <div className={styles.message3DSContainer} id="modal-content">
        <div className={styles.message3DSContent}>
          {text === "callback" && renderCallbackMessage()}
          {!show3ds && (
            <>
              {getLogo(config.brand)}
              <p>{orderStatusMessages[text]}</p>
              <div className={styles.dotFlashing} />
            </>
          )}
          {show3ds && (
            <>
              <div className={styles.message3DSIframe}>
                <iframe
                  id="3ds-iframe"
                  allow="payment *"
                  title="checkout.com 3ds iframe"
                  src={ThreeDSRedirectURL.GetThreeDSURL()}
                  className={styles.paymentFrame}
                ></iframe>
              </div>
              <div id="card"></div>
            </>
          )}
        </div>
      </div>
    </ReactModal>
  );
};

export default ExternalPaymentsOrderProgressModal;
